import PropTypes from 'prop-types';

// Components
import LazyImage from 'dibs-react-lazy-image';

// Styles
import styles from './LazyImageWrapper.module.css';

export const LazyImageWrapper = ({ children, offsetHorizontal, offsetVertical }) => {
    return (
        <LazyImage
            offsetHorizontal={offsetHorizontal}
            offsetVertical={offsetVertical}
            placeholderClass={styles.placeholder}
            placeholder={null}
        >
            {children}
        </LazyImage>
    );
};

LazyImageWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    offsetHorizontal: PropTypes.number.isRequired,
    offsetVertical: PropTypes.number.isRequired,
};
